import React from 'react';
import { Container } from 'react-bootstrap';
import { FaFacebookF, FaInstagram, FaTwitter, FaEnvelope } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="bg-dark text-white py-3">
      <Container>
        <p className="mb-0 text-center">
          © 2026 Escapio Travels. All rights reserved.
        </p>

        <div className="text-center mt-2">
          
          <a
            href="mailto:info@escapiotravels.com"
            onClick={(e) => {
              if (window.innerWidth > 768) {
                e.preventDefault();
                window.open(
                  'https://mail.google.com/mail/u/0/?view=cm&fs=1&to=info@escapiotravels.com',
                  '_blank'
                );
              }
            }}
            className="text-white mx-3"
            aria-label="Email Hidden Paradise"
          >
            <FaEnvelope size={22} />
          </a>

          
          <a 
            href="https://www.facebook.com/EscapioTravel"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="text-white mx-3"
          >
            <FaFacebookF size={20} />
          </a>

          
          <a 
            href="https://www.instagram.com/escapiotravel"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="text-white mx-3"
          >
            <FaInstagram size={20} />
          </a>

          
          <a 
            href="https://x.com/HiddenpTL"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
            className="text-white mx-3"
          >
            <FaTwitter size={20} />
          </a>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
